const filterLists = (state = {}, action) => {
    let localState = state;
    switch (action.type) {
        case 'GET_FILTERS_SUCCESS':
            localState = action.data;
            return localState;
        default:
            return localState;
    }
};

export default filterLists;
